import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';

import { Espectaculo } from '../models/espectaculo';
import { EspectaculoService } from '../services/espectaculo.service';
@Component({
  selector: 'app-espectaculos',
  templateUrl: './espectaculos.component.html',
  styleUrls: ['./espectaculos.component.css']
})
export class EspectaculosComponent implements OnInit {

  models: Espectaculo[];

  model: Espectaculo = new Espectaculo();

  filtro: FormGroup;
  url = environment.imgUrl;
  p;

  constructor(private modelService: EspectaculoService, private formBuilder: FormBuilder) {
    this.models = [];
  }

  ngOnInit() {

    this.onSubmit();
  }

  onSubmit() {

    let filter = {
    }
    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;
    });

    let filter2 = {
      "destacado": 1
    }
    this.modelService.getFilter(filter2).subscribe(val => {
      this.model = val[0];
      if (this.model == null || this.model == undefined) {
        this.model = new Espectaculo();
        this.model.imagen_horizontal = null
      }
    });

  }


}
